import type { AdaptedWallet } from '@relayprotocol/relay-sdk'
import { adaptSolanaWallet } from '@relayprotocol/relay-svm-wallet-adapter'
import {
  type Connection,
  SendTransactionError,
  type VersionedTransaction,
} from '@solana/web3.js'
import { RELAY_SOLANA_CHAIN_ID_NUMBER } from './constants'

type Base58 =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H'
  | 'J'
  | 'K'
  | 'L'
  | 'M'
  | 'N'
  | 'P'
  | 'Q'
  | 'R'
  | 'S'
  | 'T'
  | 'U'
  | 'V'
  | 'W'
  | 'X'
  | 'Y'
  | 'Z'
  | 'a'
  | 'b'
  | 'c'
  | 'd'
  | 'e'
  | 'f'
  | 'g'
  | 'h'
  | 'i'
  | 'j'
  | 'k'
  | 'm'
  | 'n'
  | 'o'
  | 'p'
  | 'q'
  | 'r'
  | 's'
  | 't'
  | 'u'
  | 'v'
  | 'w'
  | 'x'
  | 'y'
  | 'z'

export type SolanaAddress = `${Base58}${string}`

export type SolanaTxHash = `${Base58}${string}`

export type SolanaWallet = {
  address(): Promise<SolanaAddress>
  vmType: 'svm'
} & AdaptedWallet

export function getSolanaWallet(
  walletAddress: SolanaAddress,
  connection: Connection,
  signTransaction: (
    transaction: VersionedTransaction,
  ) => Promise<VersionedTransaction>,
  payerKey?: SolanaAddress,
): SolanaWallet {
  return adaptSolanaWallet(
    walletAddress,
    RELAY_SOLANA_CHAIN_ID_NUMBER,
    connection,
    async (transaction, options) => {
      const signed = await signTransaction(transaction)
      try {
        const signature = await connection.sendTransaction(signed, {
          ...options,
          maxRetries: 5,
        })

        return { signature }
      } catch (error) {
        if (error instanceof SendTransactionError) {
          console.error(
            'Failed transaction logs:',
            error,
            await error.getLogs(connection),
          )
        }

        throw error
      }
    },
    payerKey,
  ) as SolanaWallet
}
